import React from "react";
import { Typography, Box, Container, BoxProps } from "@material-ui/core";

export type PageHeaderProps = {
  title?: string;
  description?: string;
} & BoxProps;

export default function PageHeader({
  title,
  description,
  ...props
}: PageHeaderProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      paddingY={{ xs: 4, md: 10 }}
      bgcolor="background.default"
      marginBottom={{ xs: 2, md: 4 }}
      {...props}
    >
      <Typography variant="h3" component="h1">
        {title}
      </Typography>
      {description && (
        <Box marginTop={{ xs: 4, md: 4 }} textAlign="center">
          <Container maxWidth="md">
            <Typography
              component="h2"
              dangerouslySetInnerHTML={{
                __html: description
              }}
            />
          </Container>
        </Box>
      )}
    </Box>
  );
}
